import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem4,
    GridItem5,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorTextMultiline,
    TextValidatorValor,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'



const DespesasFormFinanciamentoParcelasAdicionais = ({ values, handleChange, handleSubmit, indFinanciamento }) => {

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <FieldArray name={`financiamento[${indFinanciamento}].parcelasAdicionais`}>
                {(arrayHelpers) => (
                    <DivForm>
                        <DivForm
                            style={{
                                display:
                                    values.financiamento[indFinanciamento].parcelasAdicionais &&
                                    values.financiamento[indFinanciamento].parcelasAdicionais.length > 0 ? "block" : "none"
                            }}
                        >
                            <GridContainer>
                                {values.financiamento[indFinanciamento].parcelasAdicionais?.map((item, ind) => {

                                    if (item.tipoPeriodicidadePagto === HARDCODE.idTipoPeriodicidadeUnica) {

                                        item.mesAnoFinal = item.mesAnoInicial
                                    }

                                    return (

                                        <GridItem12
                                            key={ind}
                                        >
                                            <GridContainer>
                                                <GridItem5>
                                                    <TextFieldTextSelectRequired
                                                        name={`financiamento[${indFinanciamento}].parcelasAdicionais[${ind}].tipoPeriodicidadePagto`}
                                                        label={LABEL.tipoPeriodicidadePagto}
                                                        value={item.tipoPeriodicidadePagto || ''}
                                                        onChange={handleChange}
                                                        list={tipoPeriodicidadeList(false, true, false)}
                                                    />
                                                </GridItem5>

                                                <GridItem4>
                                                    <TextValidatorValor
                                                        name={`financiamento[${indFinanciamento}].parcelasAdicionais[${ind}].valorParcela`}
                                                        label={LABEL.valorParcela}
                                                        value={item.valorParcela || ''}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem4>

                                                <GridItem2/>
                                                
                                                <GridItem1>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                    />
                                                </GridItem1>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem1/>

                                                <GridItem4>
                                                    <TextValidatorMesAnoRequired
                                                        name={`financiamento[${indFinanciamento}].parcelasAdicionais[${ind}].mesAnoInicial`}
                                                        label={LABEL.mesAnoInicial}
                                                        value={item.mesAnoInicial || ''}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem4>

                                                <GridItem4>
                                                    {item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                        <TextValidatorMesAnoRequired
                                                            name={`financiamento[${indFinanciamento}].parcelasAdicionais[${ind}].mesAnoFinal`}
                                                            label={LABEL.mesAnoFinal}
                                                            value={item.mesAnoFinal || ''}
                                                            onChange={handleChange}
                                                        />
                                                    )}
                                                </GridItem4>
                                            </GridContainer>
                                            
                                            <GridContainer>
                                                <GridItem1/>

                                                <GridItem11>
                                                    <TextValidatorTextMultiline
                                                        name={`financiamento[${indFinanciamento}].parcelasAdicionais[${ind}].observacao`}
                                                        label={LABEL.observacao}
                                                        value={item.observacao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.observacao}
                                                    />
                                                </GridItem11>
                                            </GridContainer>
                                        </GridItem12>
                                    )
                                })}
                            </GridContainer>
                        </DivForm>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirParcelasAdicionais} 
                            onClick={() => 
                                {
                                    arrayHelpers.push({
                                    })
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorFormPadrao>
    )
}

export default DespesasFormFinanciamentoParcelasAdicionais